<template>
  <div class="b2b-card cell" :class="{isPadded: 'b2b-card--padded'}">
    <div v-if="headerText" class="b2b-card__header" v-html="headerText" />
    <div class="b2b-card__img">
      <a v-if="url" :href="url" class="b2b-card__link">
        <img :src="imageUrl" />
      </a>
      <img v-else :src="imageUrl" />
    </div>
    <div class="b2b-card__body">
      <div v-if="metaText" class="b2b-card__meta mb-1" v-html="metaText" />
      <h3 class="b2b-card__title header--md">
        <a v-if="url" :href="url" class="b2b-card__link">
          <template v-html="titleText"></template>
        </a>
        <template v-else v-html="titleText"></template>
      </h3>
      <h6 v-if="subtitleText" class="b2b-card__subtitle" v-html="subtitleText" />
      <p v-if="bodyText" class="b2b-card__text" v-html="bodyText" />

      <div v-if="url && (hasBottomLink || hasBottomButton)" class="mt-2">
        <trek-link v-if="hasBottomLink" :href="url" class="mb-0">
          <span v-html="bottomText" />
        </trek-link>
        <trek-link v-else button primary :href="url" class="mb-0">
          <span v-html="bottomText" />
        </trek-link>
      </div>
    </div>
  </div>
</template>

<script>
import TrekLink from '@/components/TrekLink';

export default {
  name: 'Card',
  components: {TrekLink},
  props: {
    headerText: {
      type: String,
      default: '',
    },
    titleText: {
      type: String,
      default: '',
    },
    subtitleText: {
      type: String,
      default: '',
    },
    imageUrl: {
      type: String,
      default: '',
    },
    metaText: {
      type: String,
      default: '',
    },
    bodyText: {
      type: String,
      default: '',
    },

    url: {
      type: String,
      default: '',
    },
    isPadded: {
      type: Boolean,
      default: true,
    },
    hasBottomLink: {
      type: Boolean,
      default: false,
    },
    hasBottomButton: {
      type: Boolean,
      default: false,
    },
    bottomText: {
      type: String,
      default: '',
    },
  },
};
</script>
